import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { RenderStudio } from "@/components/admin/render/RenderStudio";

export const Route = createFileRoute("/_authenticated/admin/render")({
  head: () => ({
    meta: [
      { title: "Админ — Render Studio | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <RenderStudio />
    </AdminLayout>
  ),
});